/* mz-variant-gallery-time-pattern-pilot-v1 */
(function () {
  if (window.__mzVariantGalleryTimePatternPilotV1) return;
  window.__mzVariantGalleryTimePatternPilotV1 = true;

  function imageKey(value) {
    var raw = String(value || '').replace(/&amp;/g, '&');
    if (!raw) return '';
    try {
      var url = new URL(raw, window.location.origin);
      var parts = url.pathname.split('/');
      return decodeURIComponent(parts[parts.length - 1] || '').toLowerCase();
    } catch (error) {
      return raw.split('?')[0].split('/').pop().toLowerCase();
    }
  }

  function configuration(root) {
    if (root.__mzVariantGalleryConfiguration) return root.__mzVariantGalleryConfiguration;
    var node = root.querySelector('[data-mz-variant-gallery-config]');
    if (!node) return null;
    try {
      root.__mzVariantGalleryConfiguration = JSON.parse(node.textContent || '{}');
      return root.__mzVariantGalleryConfiguration;
    } catch (error) {
      console.error('Motorize variant gallery configuration failed', error);
      return null;
    }
  }

  function figureKey(figure) {
    var image = figure && figure.querySelector('img');
    if (!image) return '';
    return imageKey(
      image.getAttribute('data-source') ||
      image.getAttribute('data-src') ||
      image.currentSrc ||
      image.getAttribute('src') ||
      ''
    );
  }

  function setHidden(element, hidden) {
    if (!element) return;
    element.classList.toggle('mz-variant-hidden', !!hidden);
    if (hidden) {
      element.style.setProperty('display', 'none', 'important');
      element.setAttribute('aria-hidden', 'true');
    } else {
      element.style.removeProperty('display');
      element.removeAttribute('aria-hidden');
    }
  }

  function refreshThumbnailPage(root) {
    var carousel = root.querySelector('[data-mz-thumb-carousel]');
    var grid = carousel && carousel.querySelector('.mz-product-thumbs-grid');
    if (!carousel || !grid) return;

    var pageSize = 4;
    var allItems = Array.prototype.slice.call(grid.children).filter(function (item) {
      return item.classList.contains('image');
    });
    var visibleItems = allItems.filter(function (item) {
      return !item.classList.contains('mz-variant-hidden');
    });
    var selectedIndex = visibleItems.findIndex(function (item) {
      return !!item.querySelector('[data-product-gallery-selected="true"]');
    });
    if (selectedIndex < 0) selectedIndex = 0;

    var pageCount = Math.max(1, Math.ceil(visibleItems.length / pageSize));
    var page = Math.max(0, Math.min(Math.floor(selectedIndex / pageSize), pageCount - 1));
    var start = page * pageSize;
    carousel.__mzPage = page;
    carousel.__mzSelected = selectedIndex;

    allItems.forEach(function (item) {
      var visibleIndex = visibleItems.indexOf(item);
      var hidden = visibleIndex < 0 || visibleIndex < start || visibleIndex >= start + pageSize;
      item.classList.toggle('mz-gallery-page-hidden', hidden);
      item.setAttribute('aria-hidden', hidden ? 'true' : 'false');
      var button = item.querySelector('.mz-product-thumb-button');
      if (button) button.setAttribute('tabindex', hidden ? '-1' : '0');
    });

    var many = visibleItems.length > pageSize;
    var previous = carousel.querySelector('[data-mz-thumb-prev]');
    var next = carousel.querySelector('[data-mz-thumb-next]');
    if (previous) {
      previous.disabled = !many || page === 0;
      previous.style.visibility = many ? 'visible' : 'hidden';
    }
    if (next) {
      next.disabled = !many || page >= pageCount - 1;
      next.style.visibility = many ? 'visible' : 'hidden';
    }
    var status = carousel.querySelector('[data-mz-thumb-status]');
    if (status) {
      status.textContent = visibleItems.length
        ? 'Bilder ' + (start + 1) + ' bis ' + Math.min(start + pageSize, visibleItems.length) + ' von ' + visibleItems.length
        : '';
    }
  }

  function apply(root, variantId) {
    var config = configuration(root);
    if (!config) return;
    var id = String(variantId || config.selectedVariantId || '');
    var variant = (config.variants || {})[id];
    if (!variant) return;

    var allowedKeys = {};
    [variant.featured].concat(variant.images || []).forEach(function (url) {
      var key = imageKey(url);
      if (key) allowedKeys[key] = true;
    });
    var allowedMedia = {};
    var figures = Array.prototype.slice.call(root.querySelectorAll('[data-product-gallery-figure]'));
    figures.forEach(function (figure) {
      var isImage = (figure.getAttribute('data-media-type') || '') === 'image';
      var show = !isImage || !!allowedKeys[figureKey(figure)];
      setHidden(figure, !show);
      if (show) allowedMedia[String(figure.getAttribute('data-media') || '')] = true;
    });

    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-product-gallery-thumbnail]'));
    thumbs.forEach(function (thumb) {
      var mediaId = String(thumb.getAttribute('data-media') || '');
      var wrapper = thumb.closest('.image') || thumb;
      setHidden(wrapper, !allowedMedia[mediaId]);
      thumb.setAttribute('tabindex', allowedMedia[mediaId] ? '0' : '-1');
    });

    var active = root.querySelector('[data-product-gallery-figure][data-product-gallery-selected="true"]');
    if (!active || active.classList.contains('mz-variant-hidden')) {
      var firstVisible = figures.find(function (figure) {
        return !figure.classList.contains('mz-variant-hidden');
      });
      if (firstVisible) {
        var mediaId = firstVisible.getAttribute('data-media');
        var thumbnail = root.querySelector('[data-product-gallery-thumbnail][data-media="' + mediaId + '"]');
        if (thumbnail) thumbnail.click();
      }
    }

    refreshThumbnailPage(root);

    root.dataset.mzVariantGalleryCurrent = id;
    root.dataset.mzVariantGalleryVisible = String(Object.keys(allowedMedia).length);
    root.classList.add('mz-variant-gallery-ready');
  }

  function roots() {
    return Array.prototype.slice.call(document.querySelectorAll('[data-mz-variant-gallery-pilot="true"]'));
  }

  function boot() {
    roots().forEach(function (root) {
      var config = configuration(root);
      if (config) apply(root, config.selectedVariantId);
    });
  }

  window.addEventListener('product-variant-switch', function (event) {
    var variantId = event && event.detail && event.detail.variant && event.detail.variant.id;
    if (!variantId) return;
    roots().forEach(function (root) { apply(root, variantId); });
    window.setTimeout(function () {
      roots().forEach(function (root) { apply(root, variantId); });
    }, 30);
  });

  document.addEventListener('change', function (event) {
    if (!event.target || !event.target.matches('[data-product-options] select, [data-product-options] input')) return;
    window.setTimeout(function () {
      roots().forEach(function (root) {
        var section = root.closest('[data-section-type="product_page"]') || document;
        var selected = section.querySelector('[data-variants]');
        if (selected && selected.value) apply(root, selected.value);
      });
    }, 40);
  });

  document.addEventListener('shopify:section:load', boot);
  window.addEventListener('pageshow', boot);
  window.addEventListener('popstate', function () { window.setTimeout(boot, 40); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  window.__mzVariantGalleryPilotAudit = { apply: apply, imageKey: imageKey, boot: boot };
})();
